export type StateTimestamp = {
  isVisible: boolean;
  ts: number;
}
export default {
  /**
   * Returns true if the element is visible and its width and height is larger than 1.
   * We check the width and height because some element has 1px padding or margin with empty contents.
   * Ideally when the contents are empty, the element should be invisible or its height should be 0.
   * 1px check is to cover the cases incorrectly implemented.
   * @param elem {HTMLElement}
   * @return {boolean}
   */
  isVisible(elem: HTMLElement): boolean {
    const clientRec = elem.getBoundingClientRect();
    return !(window.getComputedStyle(elem).display === 'none' ||
      window.getComputedStyle(elem).visibility === 'hidden' ||
      clientRec.width <= 1 ||
      clientRec.height <= 1);
  },

  /**
   * Returns true if the visible state lasted longer than minTime.
   * @param arr {Array}
   * @param minTime {number}
   * @return {boolean}
   */
  isVisibleLongerThanMinTime(arr: Array<StateTimestamp> = [], minTime: number): boolean {
    let timeGap = 0;
    let startTime = 0;
    let endTime = 0;

    for (let i = 0; i < arr.length; i++) {
      const a = arr[i];
      if (a.isVisible) {
        startTime = a.ts;

        // If the last status is visible, use the current time as endTime.
        if (i === arr.length - 1) {
          endTime = performance.now();
        }
      } else {
        endTime = a.ts;
      }

      if (endTime > startTime) {
        timeGap = endTime - startTime;
      }

      if (timeGap >= minTime) {
        return true;
      }
    }

    return false;
  },

  /**
   * Returns true if the element has data-component-name or id,
   * or the element is button or anchor tag.
   * @param elem {HTMLElement}
   * @return {HTMLElement}
   */
  getElemToTrackForClick(elem: HTMLElement): HTMLElement {
    const clickable = ['BUTTON', 'A'];
    if (clickable.includes(elem.tagName)) {
      return elem;
    }

    if (elem.dataset?.componentName || elem.id) {
      return elem;
    }

    while (elem.parentElement) {
      elem = elem.parentElement;

      if (elem.tagName === 'BODY') {
        return null;
      }

      if (elem.dataset?.componentName) {
        return elem;
      }
    }

    return null;
  }
}
